<template>
  <div class="fieldset">
    <h3 class="fieldset-heading">Primary Distribution</h3>

    <PartnerPrimaryYN v-if="partner"
                      v-model="form.data.distributionPrimary.details.partnerPrimaryYN"
                      :callback-function="handlePartnerAsPrimary"/>

    <template v-if="(partner && dataPrimary.partnerPrimaryYN === false) || !partner">
      <transition name="fade">
        <ShareObjects
            v-model="form.data.distributionPrimary.details.shares"
            :details="dataPrimary"
            :optionsData="primaryOptions"
            :title="primaryQuestionTitle"
            button-text="Add Primary Beneficiary"
            location="distributionPrimary"/>
      </transition>

      <div v-for="(share, index) in dataPrimary.shares"
           :key="'distributionPrimaryBackupShare' + index">
        <template
            v-if="!(share.recipients.length === 1 && share.recipients.filter(person => person.type === 'charity').length === 1)">

          <ShareStirpes
              v-model="form.data.distributionPrimary.details.shares[index].stirpes"
              :index="index"
              :share="share"
              location="distributionPrimary"/>

          <div
              v-if="dataPrimary.shares[index].stirpes || ((!share.recipients.filter(person => person.type === 'group').length && dataPrimary.shares.length > 1) && dataPrimary.shares[index].stirpes !== null || dataPrimary.shares[index].backupsYN)"
              class="question-box with-arrow">
            <ShareStirpesAge
                v-if="dataPrimary.shares[index].stirpes"
                v-model="form.data.distributionPrimary.details.shares[index].stirpesAge"
                :index="index"
                :share="share"
                location="distributionPrimary"/>
            <template
                v-if="!share.recipients.filter(person => person.type === 'group').length && dataPrimary.shares.length > 1">
              <ShareBackupYN
                  v-if="dataPrimary.shares[index].stirpes !== null"
                  v-model="form.data.distributionPrimary.details.shares[index].backupsYN"
                  :callback-function="handleBackupShare"
                  :index="index"
                  :share="share"
                  :shares="dataPrimary.shares"
                  location="distributionPrimary"/>

              <template v-if="dataPrimary.shares[index].backupsYN">
                <ShareBackupRecipients
                    v-for="(person, i) in dataPrimary.shares[index].recipients"
                    :key="`share${index}BackupPerson${i}`"
                    v-model="form.data.distributionPrimary.details.shares[index].recipients[i].recipients"
                    :details="dataPrimary.shares[index].recipients[i]"
                    :optionsData="primaryOptions.filter(option => option.id !== dataPrimary.shares[index].recipients[i].id)"
                    :recipientIndex="i"
                    :shareIndex="index"
                    location="distributionPrimary"/>
              </template>
            </template>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import {willPeopleHelpers} from "./helpers/willPeopleHelpers";
import {fieldsetHelpers} from "../fieldsetHelpers";
import {clone} from "@/mixins/clone";
import {saveHelpers} from "@/views/questionnaires/saveHelpers";
import {willDistributionHelpers} from "./helpers/willDistributionHelpers";
import {willRelationshipHelpers} from "./helpers/willRelationshipHelpers";
import {personHelpers} from "@/mixins/personHelpers";

import PartnerPrimaryYN from "../../question/questions/will/distribution/PartnerPrimaryYN";
import ShareObjects from "../../question/questions/will/distribution/ShareObjects";
import ShareBackupRecipients from "../../question/questions/will/distribution/ShareBackupRecipients";
import ShareStirpes from "../../question/questions/will/distribution/ShareStirpes";
import ShareBackupYN from "../../question/questions/will/distribution/ShareBackupYN";
import ShareStirpesAge from "../../question/questions/will/distribution/ShareStirpesAge";

export default {
  name: 'DistributionPrimary',
  mixins: [
    fieldsetHelpers,
    willPeopleHelpers,
    clone,
    saveHelpers,
    willDistributionHelpers,
    willRelationshipHelpers,
    personHelpers
  ],
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  components: {
    ShareStirpesAge,
    ShareBackupYN,
    ShareStirpes,
    ShareBackupRecipients,
    ShareObjects,
    PartnerPrimaryYN
  },
  data() {
    return {
      label: 'Primary', // used for steps progress
      dbPrimary: {
        saveLocation: 'product_will_data',
        saveField: 'details',
        formPath: 'data.distributionPrimary.details'
      },
      dbSecond: {
        saveLocation: 'product_will_data',
        saveField: 'details',
        formPath: 'data.distributionSecondary.details'
      },
      dbBackup: {
        saveLocation: 'product_will_data',
        saveField: 'details',
        formPath: 'data.distributionBackup.details'
      },
      primaryOptions: [],
      secondaryOptions: [],
      backupOptions: [],
    }
  },
  computed: {
    form: {
      set(value) {
        this.$emit('input',
            value)
      },
      get() {
        return this.value
      }
    }
  },
  methods: {
    people(share) {
      return this.listPeopleAddressDob({
        people: share.recipients,
        firstName: true,
        noDob: true
      })
    }
  }
};
</script>
